<template>
	<div class="d-flex j-center ">
		<div class="content-box ">
			<div  class="d-flex a-center" style="cursor: pointer;">
				<div @click="$router.back()" style="width: 13px;height: 13px;display: flex;align-items: center;">
					<img style="width: 13px;height: 13px;transform: rotate(180deg);" src="../../assets/brand_fixtures/jiantou (4).png" />
				</div>
				<div @click="$router.back()" style="font-size: 16px;color: #4a86ff;margin-left: 6px;">返回</div>
				
			</div>
			<div class="d-flex" style="margin-top: 22px;">
				<div style="width: 397px;height: auto;">
					<div @click="selIndex=1" style="width: 375px;height: 204px;background: #F8F8F8;border-radius: 10px;
					box-sizing: border-box;padding: 0 12px;cursor: pointer;" :style="selIndex==1?'border: 1px solid #1E69FF':''">
						<div style="height: 40px;display: flex;align-items: center;">
							<div style="width: 3px;height: 15px;background: #000000;">
							</div>
							<div style="font-size: 14px;font-weight: 600;margin-left: 4px;">banner模块</div>
						</div>
						<el-carousel  height="150px">
						  <el-carousel-item v-for="(item,index) in dyList" :key="index">
							<img style="width: 349px;height: 150px;" :src="item.photo_path" />
						  </el-carousel-item>
						</el-carousel>
					</div>
					<div @click="selIndex=2" style="width: 375px;height: 204px;background: #F8F8F8;border-radius: 10px;margin-top: 14px;
					box-sizing: border-box;padding: 0 12px;cursor: pointer;" :style="selIndex==2?'border: 1px solid #1E69FF':''">
						<div style="height: 40px;display: flex;align-items: center;">
							<div style="width: 3px;height: 15px;background: #000000;">
							</div>
							<div style="font-size: 14px;font-weight: 600;margin-left: 4px;">功能模块</div>
						</div>
						<div style="border-radius: 10px;">
							<div v-for="(item,index) in use_module" :key="index"
							style="width: 20%;text-align: center;display: inline-block;margin-top: 10px;">
								<div v-if="user_info.fcib_module_tpl_id == 0" style="width: 39px;height: 39px;cursor: pointer;border-radius: 50%;display: inline-block;box-shadow: 0px 6px 8px 0px #cccccc;" 
								:style="'background:'+user_info.fcib_member_list_color">
									<img style="width: 39px;height: 39px;" :src="item.photo_url" />
								</div>
								<div v-else style="width: 39px;height: 39px;cursor: pointer;border-radius: 50%;display: inline-block;box-shadow: 0px 6px 8px 0px #cccccc;">
									<img style="width: 39px;height: 39px;" :src="item.photo_url" />
								</div>
								<div style="font-size: 12px;">{{item.title}}</div>
							</div>
						</div>
					</div>
					<div @click="selIndex=3" style="width: 375px;background: #F8F8F8;border-radius: 10px;margin-top: 14px;
					box-sizing: border-box;padding: 0 12px;cursor: pointer;" :style="selIndex==3?'border: 1px solid #1E69FF':''">
						<div style="height: 40px;display: flex;align-items: center;">
							<div style="width: 3px;height: 15px;background: #000000;">
							</div>
							<div style="font-size: 14px;font-weight: 600;margin-left: 4px;">产品服务</div>
						</div>
						<div style="display: flex;flex-wrap: wrap;justify-content: space-between;box-sizing: border-box;">
							<template v-if="serviceGoodsList.length == 0">
								<div v-for="(item,index) in serviceNum" :key="index"
								style="width: 170px;height: 230px;border-radius: 10px;background: #FFFFFF;margin-bottom: 14px;">
									
								</div>
							</template>
							<template v-else>
								<div v-for="(item,index) in serviceGoodsList" :key="index"
								style="width: 170px;height: 230px;border-radius: 10px;background: #FFFFFF;margin-bottom: 14px;box-sizing: border-box;">
									<div style="width: 170px;height: 170px;border-radius: 10px 10px 0 0;">
										<img :src="item.goods_thumb" style="width: 170px;height: 170px;border-radius: 10px 10px 0 0;" alt="">
									</div>
									<div class="" style="width: 100%;box-sizing: border-box;border-radius: 0 0 10px 10px;padding: 10px;color: #000;font-size: 14px;font-weight: 600;overflow: hidden;">
										<div class="text-second">{{item.goods_name}}</div>
									</div>
								</div>
							</template>
						</div>
					</div>
					<img style="width: 397px;height: 1736px;margin-top: 14px;" src="../../assets/brand_fixtures/beijin.png" />
				</div>
				<div style="margin-left: 100px;flex: 1;">
					<div style="display: flex;align-items: center;font-size: 14px;font-weight: 600;">
						<div style="position: relative;cursor: pointer;" @click="tabState=!tabState" :style="tabState==true?'color:#1E69FF;':'color:#000000;'">
							首页内容设定
							<div v-if="tabState==true" style="position: absolute;width: 100%;height: 2px;background-color: #1E69FF;"></div>
						</div>
						<div style="margin-left: 55px;position: relative;cursor: pointer;" @click="tabState=!tabState" :style="tabState==false?'color:#1E69FF;':'color:#000000;'">
							模块顺序设定
							<div v-if="tabState==false" style="position: absolute;width: 100%;height: 2px;background-color: #1E69FF;"></div>
						</div>
					</div>
					<template v-if="tabState==true">
						<template v-if="selIndex == 1">
							<div style="display: flex;align-items: center;margin-top: 30px;margin-bottom: 20px;">
								<div style="color: #000000;font-size: 12px;font-weight: 600;">自定义内容优先级高于链接</div>
								<div @click="addDylist()" style="font-size: 14px;color: #1E69FF;margin-left: auto;font-weight: 600;">
									+添加新banner
								</div>
							</div>
							<div v-for="(item,index) in dyList" :key="index">
								<div class="d-flex">
									<div>
										<el-upload style="cursor: pointer;width: 351px;height: 150px;"
										  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
										  :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
										  :show-file-list="false"
										  :on-success="(res,fileList)=>getimg(res,fileList,index,item)"
										  accept='.jpg,.png,.jpeg'>
										  <div style="width: 351px;height: 150px;background: #EEEEEE;border-radius: 5px;" class="d-flex a-center j-center">
											  <div style="text-align: center;">
												  <img v-if="item.photo_path" style="width: 351px;height: 150px;" :src="item.photo_path"/>
												  <img v-else style="width: 351px;height: 150px;" src="../../assets/brand_fixtures/zanwuguanggao.png" />
											  </div>
										  </div>
										</el-upload>
									</div>
									<div style="margin-left: 6px;">
										<!-- <div @click="setBanner(index)" style="width: 54px;height: 18px;border: 1px solid #888888;
										border-radius: 3px;font-size: 12px;cursor: pointer;"
										class="d-flex a-center j-center">
											<div class="d-flex a-center">
												<div>设置</div>
											</div>	
										</div>
										<div v-if="item.type != 0" @click="$router.push('examine_banner?id='+item.id+'&type='+item.type)" style="width: 54px;height: 18px;border: 1px solid #888888;
										border-radius: 3px;font-size: 12px;margin-top: 11px;cursor: pointer;position: relative;"
										class="d-flex a-center j-center">
											<div v-if="item.not_sign" style="width: 16px;height: 16px;border-radius: 50%;position: absolute;right: -8px;top: -8px;
											border: 1px solid #FF2323;background: #FFFFFF;font-size: 12px;color: #FF2323;" class="d-flex a-center j-center">
												{{item.not_sign}}
											</div>
											<div class="d-flex a-center">
												<div>审查</div>
											</div>	
										</div> -->
										<div @click="delDylist(index,item)" style="width: 54px;height: 18px;border: 1px solid #888888;
										border-radius: 3px;font-size: 12px;margin-top: 11px;cursor: pointer;"
										class="d-flex a-center j-center">
											<div class="d-flex a-center">
												<div>删除</div>
											</div>	
										</div>
										<div @click="upFiles(index)" style="width: 54px;height: 18px;border: 1px solid #888888;
										border-radius: 3px;font-size: 12px;margin-top: 11px;cursor: pointer;"
										class="d-flex a-center j-center">
											<div class="d-flex a-center">
												<div>上移</div>
											</div>	
										</div>
										<div @click="dowFiles(index)" style="width: 54px;height: 18px;border: 1px solid #888888;
										border-radius: 3px;font-size: 12px;margin-top: 11px;cursor: pointer;"
										class="d-flex a-center j-center">
											<div class="d-flex a-center">
												<div>下移</div>
											</div>	
										</div>
										<!-- <div @click="fcib_index_banner_save_v2(item)" style="width: 54px;height: 18px;border: 1px solid #888888;
										border-radius: 3px;font-size: 12px;margin-top: 11px;cursor: pointer;"
										class="d-flex a-center j-center">
											<div class="d-flex a-center">
												<div>保存</div>
											</div>	
										</div> -->
									</div>
								</div>
								<div style="margin-top: 11px;font-size: 14px;font-weight: 600;" class="d-flex a-center">
									<div>banner(广告)跳转链接</div> 
									<div @click="setzdyState(index,item)" style="color: #1E69FF;margin-left: 135px;cursor: pointer;" >自定义内容</div>
									<img style="width: 12px;height: 12px;" src="../../assets/brand_fixtures/jiantoul.png" />
								</div>
								<el-input v-model="item.link" placeholder="请输入跳转链接" size="small" style="margin-top: 11px;margin-bottom: 30px;width: 351px;"></el-input>
							</div>
							<div style="margin-top: 21px;width: 150px;height: 36px;background: #1E69FF;
							border-radius: 4px;font-size: 14px;color: #FFFFFF;cursor: pointer;" v-if="dyList && dyList.length != 0"
							class="d-flex a-center j-center" @click="fcib_index_banner_save">
								保存
							</div>
						</template>
						<template v-else-if="selIndex==2">
							<div class="d-flex a-center" style="margin-top: 30px;">
								<img v-if="user_info.fcib_module_tpl_id == 1" 
								style="width: 18px;height: 18px;cursor: pointer;" 
								src="../../assets/itemStore/xuanzhong@2x.png" />
								<img @click="setModel(1)" v-else style="width: 18px;height: 18px;cursor: pointer;"
								src="../../assets/itemStore/moren@2x.png" />
								<div @click="setModel(1)" style="font-size: 14px;margin-left: 5px;cursor: pointer;">
									使用多彩版 <span style="color: #888888;">(点进图标可直接进入编辑内容)</span>
								</div>
								<div @click="get_fcib_all_module()" v-if="user_info.fcib_module_tpl_id == 1" class="d-flex a-center ml-auto" style="cursor: pointer;">
									<div style="width: 15px;height: 15px;" class="d-flex a-center">
										<img style="width: 15px;height: 15px;" src="../../assets/Home/bianji@2x.png" />
									</div>
									<div style="font-size: 14px;margin-left: 3px;color: #1E69FF;">编辑</div>
								</div>
							</div>
							<div class="d-flex a-center" style="margin-top: 40px;">
								<img v-if="user_info.fcib_module_tpl_id == 0" 
								style="width: 18px;height: 18px;cursor: pointer;" 
								src="../../assets/itemStore/xuanzhong@2x.png" />
								<img @click="setModel(0)" v-else style="width: 18px;height: 18px;cursor: pointer;"
								src="../../assets/itemStore/moren@2x.png" />
								<div @click="setModel(0)" style="font-size: 14px;margin-left: 5px;cursor: pointer;">
									使用自定义纯色版 <span style="color: #888888;">(点进图标可直接进入编辑内容)</span>
								</div>	
								<div @click="get_fcib_all_module()" v-if="user_info.fcib_module_tpl_id == 0" class="d-flex a-center ml-auto" style="cursor: pointer;">
									<div style="width: 15px;height: 15px;" class="d-flex a-center">
										<img style="width: 15px;height: 15px;" src="../../assets/Home/bianji@2x.png" />
									</div>
									<div style="font-size: 14px;margin-left: 3px;color: #1E69FF;">编辑</div>
								</div>
								<div v-if="user_info.fcib_module_tpl_id == 0" class="d-flex a-center" style="font-size: 14px;height: 32px;color: #1E69FF;position: relative;">
									<el-color-picker @change="changeColor()" v-model="user_info.fcib_member_list_color" size="small" style="margin-left: auto;opacity: 0;z-index: 2;"></el-color-picker>
									<img style="width: 15px;height: 15px;position: absolute;left: 13px;z-index: 1;" src="../../assets/Home/xzys.png" />
									改色
								</div>
							</div>
							<div>
								<div style="background: #FFFFFF;border-radius: 10px;">
									<div v-for="(item,index) in use_module" :key="index" @click="constitution(item)"
									style="width: 20%;text-align: center;display: inline-block;margin-top: 35px;">
										<div v-if="user_info.fcib_module_tpl_id == 0" style="width: 39px;height: 39px;cursor: pointer;border-radius: 50%;display: inline-block;box-shadow: 0px 6px 8px 0px #cccccc;" 
										:style="'background:'+user_info.fcib_member_list_color">
											<img style="width: 39px;height: 39px;" :src="item.photo_url" />
										</div>
										<div v-else style="width: 39px;height: 39px;cursor: pointer;border-radius: 50%;display: inline-block;box-shadow: 0px 6px 8px 0px #cccccc;">
											<img style="width: 39px;height: 39px;" :src="item.photo_url" />
										</div>
										<div style="font-size: 12px;">{{item.title}}</div>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div style="margin-top: 30px;width: 360px;">
								<div style="display: flex;align-items: center;justify-content: space-between;">
									<div style="display: flex;align-items: center;color: #888888;font-size: 14px;font-weight: 600;" @click="serviceClick(item,index)" v-for="(item,index) in serviceTab" :key="item.num">
										<img style="width: 18px;height: 18px;cursor: pointer;margin-right: 6px;" 
										:src="serviceNum==item.num?require('../../assets/itemStore/xuanzhong@2x.png'):require('../../assets/itemStore/moren@2x.png')" />
										{{'显示'+item.tag+'个'}}
									</div>
								</div>
								<div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
									<div v-for="(item,index) in serviceNum" :key="index"  @click="chooseGoods"
									style="width: 120px;height: 120px;border-radius: 4px;background-color: #F5F5F5;flex-direction: column;cursor: pointer;
									margin-right: 12px;margin-bottom: 12px;display: flex;align-items: center;justify-content: center;box-sizing: border-box;">
										<img src="../../assets/brand_fixtures/xuanz@2x.png" style="width: 24px;height: 24px;" alt="">
										<div style="color: #888888;font-size: 12px;font-weight: 600;padding-top: 10px;">选择商品</div>
									</div>
								</div>
								<div @click="saveSelGoods" style="width: 150px;height: 36px;border-radius: 4px;background-color: #1E69FF;margin-top: 10px;cursor: pointer;
								color: #FFFFFF;font-size: 14px;font-weight: 600;display: flex;align-items: center;justify-content: center;">保存</div>
							</div>
						</template>
					</template>
					<template v-else>
						<div style="box-sizing: border-box;margin-top: 30px;color: #666666;font-size: 14px;font-weight: 600;">
							<div style="box-sizing: border-box;display: flex;align-items: center;margin-top: 27px;" v-for="(item,index) in sortList" :key="item.sort">
								<div style="width: 144px;">
									{{item.name}}
								</div>
								<div style="display: flex;align-items: center;">
									<template v-if="item.sort==1 || item.sort==2">
										<img src="../../assets/new_img/sahngwu@2x.png" @click="modelLeftClick(item,index)" style="width: 12px;height: 14px;cursor: pointer;" alt="">
										<img src="../../assets/new_img/xiawu@2x.png" @click="modelRightClick(item,index)" style="width: 12px;height: 14px;margin-left: 10px;cursor: pointer;" alt="">
									</template>
									<template v-else>
										<template v-if="item.sort == 3">
											<img src="../../assets/new_img/sahngwu@2x.png" @click="modelLeftClick(item,index)" style="width: 12px;height: 14px;cursor: pointer;" alt="">
											<img src="../../assets/new_img/xiayou@2x.png" @click="modelRightClick(item,index)" style="width: 12px;height: 14px;margin-left: 10px;cursor: pointer;" alt="">
											<!-- <img src="../../assets/new_img/yincang@2x.png" style="width: 14px;height: 14px;margin-left: 10px;cursor: pointer;;" alt=""> -->
										</template>
										<template v-else-if="item.sort == 6">
											<img src="../../assets/new_img/sahngyou@2x.png" @click="modelLeftClick(item,index)" style="width: 12px;height: 14px;cursor: pointer;" alt="">
											<img src="../../assets/new_img/xiawu@2x.png" @click="modelRightClick(item,index)" style="width: 12px;height: 14px;margin-left: 10px;cursor: pointer;" alt="">
											<!-- <img src="../../assets/new_img/yincang@2x.png" style="width: 14px;height: 14px;margin-left: 10px;cursor: pointer;;" alt=""> -->
										</template>
										<template v-else>
											<img src="../../assets/new_img/sahngyou@2x.png" @click="modelLeftClick(item,index)" style="width: 12px;height: 14px;cursor: pointer;" alt="">
											<img src="../../assets/new_img/xiayou@2x.png" @click="modelRightClick(item,index)" style="width: 12px;height: 14px;margin-left: 10px;cursor: pointer;" alt="">
										</template>
										<img :src="item.hide==0?require('../../assets/new_img/xxianshi@2x.png'):require('../../assets/new_img/yincang@2x.png')" @click="checkHideStatus(item,index)"
										style="width: 14px;height: 14px;margin-left: 10px;cursor: pointer;;" alt="">
									</template>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<el-dialog
		  :modal="true"
		  title="编辑首页功能模块"
		  :visible.sync="moduleState"
		  width="1000px"
		  center>
		  <div class="text-center" style="font-size: 14px;color: #888888;">
			  勾选即表示在首页“功能模块”显示，不勾选即不在首页“功能模块”显示(最少显示8个)
		  </div>
		  <div style="padding: 0 122px;margin-top: 30px;">
		  	<div style="background: #FFFFFF;border-radius: 10px;">
		  		<div v-for="(item,index) in selModel" :key="index" @click="useModel(item)"
		  		style="width: 20%;text-align: center;display: inline-block;box-sizing: border-box;padding: 11px 0;
				border-radius: 6px;background: #EEEEEE;margin: 15px 10px;cursor: pointer;position: relative;">
					<div style="position: absolute;top: 8px;right: 8px;">
						<img v-if="item.is_use == 1"
						style="width: 18px;height: 18px;cursor: pointer;" 
						src="../../assets/itemStore/xuanzhong@2x.png" />
						<img v-else style="width: 18px;height: 18px;cursor: pointer;"
						src="../../assets/itemStore/moren@2x.png" />
					</div>
		  			<div v-if="user_info.fcib_module_tpl_id == 0" 
					style="width: 39px;height: 39px;border-radius: 50%;
					display: inline-block;box-shadow: 0px 6px 8px 0px #cccccc;" 
		  			:style="'background:'+user_info.fcib_member_list_color">
		  				<img style="width: 39px;height: 39px;" :src="item.photo_url" />
		  			</div>
		  			<div v-else style="width: 39px;height: 39px;border-radius: 50%;display: inline-block;box-shadow: 0px 6px 8px 0px #cccccc;">
		  				<img style="width: 39px;height: 39px;" :src="item.photo_url" />
		  			</div>
		  			<div style="font-size: 12px;">{{item.title}}</div>
		  		</div>
		  	</div>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="moduleState = false">取 消</el-button>
		    <el-button size="mini" type="primary" @click="get_fcib_module_set" >保 存</el-button>
		  </span>
		</el-dialog>
		<el-dialog
			title="选取首页服务商品"
			:visible.sync="servicegoodsstate"
			width="1000px"
			center>
		  <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;">
			  <div>选择产品/服务</div>
			  <div>
				 <el-input placeholder="商品关键字搜索" v-model="goodsKeyword" style="width: 280px;margin: 21px 0;" size="small">
				   <el-button slot="append" icon="el-icon-search" @click.native="serachGoods"></el-button>
				 </el-input>
			  </div>
		  </div>
		  <div style="padding: 0 0;margin-top: 0px;height: 600px;overflow-y: scroll;box-sizing: border-box;" class="product-content">
		  	<div style="background: #FFFFFF;border-radius: 10px;display: flex;align-items: center;box-sizing: border-box;flex-wrap: wrap;">
		  		<div v-for="(item,index) in goodsList" :key="index" @click="setGoods(item)"
		  		style="width: 31%;display: flex;align-items: center; box-sizing: border-box;padding: 10px 0;
		  			border-radius: 6px;margin: 15px 10px;cursor: pointer;">
					<div style="box-sizing: border-box;">
						<img v-if="item.checked"
						style="width: 18px;height: 18px;cursor: pointer;" 
						src="../../assets/itemStore/xuanzhong@2x.png" />
						<img v-else style="width: 18px;height: 18px;cursor: pointer;"
						src="../../assets/itemStore/moren@2x.png" />
					</div>
					<div style="display: flex;align-items: center;margin-left: 8px;">
						<div style="width: 60px;height: 60px;">
							<img :src="item.goods_thumb" style="width: 60px;height: 60px;border-radius: 4px;" alt="">
						</div>
						<div style="margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;color: #666666;font-size: 12px;height: 60px;">
							<div class="text-second">{{item.goods_name}}</div>
							<div>发布时间：{{item.add_time}}</div>
						</div>
					</div>
		  		</div>
		  	</div>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="servicegoodsstate = false">取 消</el-button>
		    <el-button type="primary" @click="selectProduct()">保 存</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  :modal="true"
		  title="添加自定义内容"
		  :visible.sync="zdyState"
		  width="1000px"
		  center>
		  <div class="" style="text-align: center;">
			  <div class="d-flex a-center j-center" style="margin-top: 15px;">
			  	<div style="width: 356px;display: flex;align-items: center;">
			  		<div style="color: #666666;font-size: 14px;">内容标题：</div>
			  		<el-input v-model="title" size="mini" style="width: 286px;"></el-input>
			  	</div>
			  </div>
			  <div class="d-flex j-center" style="margin-top: 15px;">
			  	<div style="width: 365px;height: 660px;border: 1px solid #979797;border-radius: 6px;overflow: hidden;">
			  		<div style="width: 100%;height: 48px;background: #f5f5f5;" class="d-flex">
			  			<div @click="txtShow=true" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
			  				<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/wenzi.png" />
			  				<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">文字</div>
			  			</div>
			  			<el-upload style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center"
			  			  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
			  			  :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
			  			  :show-file-list="false"
			  			  :on-success="getLiveDylist"
			  			  accept='.jpg,.png,.jpeg'>
			  			  <div style="cursor: pointer;width: 100%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
			  				<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/itemStore/tupian@2x.png" />
			  				<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">图片</div>
			  			  </div>
			  			</el-upload>
			  			<div @click="setcenter()" style="cursor: pointer;width: 16.666%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
			  				<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/juzhong.png" />
			  				<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">居中</div>
			  			</div>
			  			<div @click="upFiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
			  				<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/san.png" />
			  				<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">上移</div>
			  			</div>
			  			<div @click="dowFiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
			  				<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/itemStore/xiayi@2x.png" />
			  				<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">下移</div>
			  			</div>
			  			<div @click="delfiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
			  				<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/wu.png" />
			  				<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">删除</div>
			  			</div>
			  		</div>
			  		<div class="txt-box d-flex" style="height: 612px;width: 100%;overflow-y: scroll;flex-wrap: wrap;">
			  			<div style="width: 100%;">
			  				<div style="font-size: 16px;font-weight: 700;color: #000000;text-align: center;
			  				box-sizing: border-box;padding: 5px 30px;text-align: center;">
			  					{{title}}
			  				</div>
			  				<!-- <div v-if="title" style="font-size: 12px;padding: 3px 6px;color: #002451;display: flex;justify-content: center;">
			  					{{user_info.company_name}}<span style="color: #888888;margin-left: 6px;">{{getyymmdd()}}</span> 
			  				</div> -->
			  				<template v-for="(img,imgkey) in zdyList">
			  					<img v-if="img.type == 2" style="width: 365px;box-sizing: border-box;display: block;"
			  					:style="imgkey === dyIndex?'border: 1px dashed #1E69FF;':''"
			  					@click="dyIndex = imgkey" :src="img.content" />
			  					<div @click="dyIndex = imgkey" :style="imgkey === dyIndex?'border: 1px dashed #1E69FF;':''"
			  					v-else style="padding: 3px 6px;font-size: 15px;color: #666;cursor: pointer;"
			  					:class="img.type == 3?'tct':'ntxt'">
			  						{{img.content}}
			  					</div>
			  				</template>
			  			</div>
			  		</div>
			  	</div>
			  </div>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="zdyState = false">取 消</el-button>
		    <el-button size="mini" type="primary" @click="fcib_index_banner_content_save" >确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="文本信息"
		  :visible.sync="txtShow"
		  width="30%"
		  top="30vh">
		  <el-input
		    type="textarea"
		    :autosize="{ minRows: 2, maxRows: 4}"
		    placeholder="请输入内容"
		    v-model="txt">
		  </el-input>
		  
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="txtShow=false" size="small" >取 消</el-button>
		    <el-button @click="setTxt()" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="banner设定"
		  :visible.sync="bannerShow"
		  width="927px"
		  top="30vh"
		  center>
		  <div style="font-size: 14px;color: #888888;text-align: center;">
			  设定不同的广告位置开放功能不一样，一张办banner广告只能设定一种类型
		  </div>
		  <div v-if="dyList.length" style="padding: 0 148px;box-sizing: border-box;margin-top: 25px;">
			  <div style="display: flex;align-items: center;">
				  <div style="width: 3px;height: 12px;background: #000000;border-radius: 2px;"></div>
				  <div style="font-size: 14px;font-weight: 600;margin-left: 10px;color: #000000;">广告位类型</div>
			  </div>
			  <div style="display: flex;align-items: center;margin-top: 25px;justify-content: space-between;">
				  <div style="display: flex;align-items: center;">
					<img v-if="dyList[bannerIndex].type == 0" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/itemStore/xuanzhong@2x.png"/>
					<img @click="dyList[bannerIndex].type = 0" v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/itemStore/moren@2x.png"/>
					<div @click="dyList[bannerIndex].type = 0" style="margin-left: 10px;font-size: 14px;cursor: pointer;">商会普通banner</div>
				  </div>
				  <div style="display: flex;align-items: center;">
					<img v-if="dyList[bannerIndex].type == 1" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/itemStore/xuanzhong@2x.png"/>
					<img @click="dyList[bannerIndex].type = 1" v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/itemStore/moren@2x.png"/>
					<div @click="dyList[bannerIndex].type = 1" style="margin-left: 10px;font-size: 14px;cursor: pointer;">商会成员企业每日推荐banner</div>
				  </div>
				  <div style="display: flex;align-items: center;">
					<img v-if="dyList[bannerIndex].type == 2" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/itemStore/xuanzhong@2x.png"/>
					<img @click="dyList[bannerIndex].type = 2" v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/itemStore/moren@2x.png"/>
					<div @click="dyList[bannerIndex].type = 2" style="margin-left: 10px;font-size: 14px;cursor: pointer;">对外开放付费banner</div>
				  </div>
			  </div>
			  <div style="display: flex;align-items: center;margin-top: 50px;">
				  <div style="width: 3px;height: 12px;background: #000000;border-radius: 2px;"></div>
				  <div style="font-size: 14px;font-weight: 600;margin-left: 10px;color: #000000;">广告位类型</div>
			  </div>
			  <div v-if="dyList[bannerIndex].type == 2" style="display: flex;align-items: center;font-size: 14px;margin-top: 16px;">
				  <div>请设置市场计费价格：</div>
				  <el-input v-model="dyList[bannerIndex].price" placeholder="请输入" size="small" style="width: 150px;"/>
				  <div style="color: #FF2323">元/周</div>
			  </div>
			  <div style="font-size: 14px;color: #888888;margin-top: 16px;">按入驻广告位时间起计算7天时间，到期自动删除banner广告</div>
		  </div>
		  
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="bannerShow=false" size="small" >取 消</el-button>
		    <el-button @click="bannerShow=false" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
	</div>
	
</template>

<script>
	export default{
		data(){
			return{
				token: localStorage.getItem('token'),
				user_id: localStorage.getItem('user_id'),
				user_info:'',
				dyList:[
					// {photo_path:'',link:'',con_id:0,price:0,type:0}
				],
				selIndex:1,
				use_module:[],
				moduleState:false,
				selModel:[],
				zdyState:false,
				
				token:localStorage.getItem('token'),
				user_id:localStorage.getItem('user_id'),
				curIndex:0,
				zdyList:[],
				imgindex:'',
				dyIndex:'',
				txt:'',
				txtShow:false,
				title:'',
				cover:'',
				zdyIndex:'',
				con_id:'',
				bannerShow:false,
				bannerIndex:0,
				
				tabState:true,
				serviceTab:[
					{num:2,tag:'两'},
					{num:4,tag:'四'},
					{num:6,tag:'六'},
				],
				currentService:1,
				serviceNum:4,
				serviceGoodsList:[],
				goodsList:[],
				servicegoodsstate:false,
				goodsKeyword:'',
				
				sortList:[
					{sortName:'产品服务',sort:1},
					{sortName:'合作伙伴',sort:2},
					{sortName:'企业动态',sort:3},
					{sortName:'企业发布',sort:4}
				]
			}
		},
		created() {
			this.fcib_index_banner_list()
			this.get_company_info()
			this.get_fcib_use_module()
			this.co_index_banner_list()
			this.get_co_index_goods_list()
			this.co_index_module_sort_info()
		},
		methods:{
			setBanner(index){
				this.bannerShow = true
				this.bannerIndex = index
			},
			fcib_index_banner_save_v2(item){
				// if(item.photo_path == ''){
				// 	this.$message({
				// 		showClose: false,
				// 		message: '请上传图片',
				// 		type: 'error',
				// 		offset: 350,
				// 		duration: 1500
				// 	})
				// 	return
				// }
				let params = {
					act:'fcib_index_banner_save_v2',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					json_data:''
				}
				this.$api.fcib_home_page_tpl_create(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '保存成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			fcib_index_banner_content_save(){
				if(this.title == ''){
					this.$message({
						showClose: false,
						message: '标题不能为空',
						type: 'error',
						offset: 350,
						duration: 200
					})
					return
				}
				if(this.zdyList.length == 0){
					this.$message({
						showClose: false,
						message: '内容不能为空',
						type: 'error',
						offset: 350,
						duration: 200
					})
					return
				}
				let params = {
					act:'fcib_index_banner_content_save',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					source:0,//0内容数组，1编辑器
					title:this.title,
					content:this.zdyList,
					con_id:this.con_id
				}
				this.$api.get_fcib_all_module(params).then((res)=>{
					this.dyList[this.zdyIndex].con_id = res.data.con_id
					this.zdyState = false
				})
			},
			setzdyState(index,item){
				this.con_id = item.con_id
				this.title = ''
				this.zdyList = []
				if(item.con_id != 0){
					let params = {
						act:'fcib_index_banner_content_info',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						con_id:item.con_id
					}
					this.$api.get_fcib_all_module(params).then((res)=>{
						this.title = res.data.title
						this.zdyList = res.data.content
						this.zdyState = true
						this.zdyIndex = index
					})
				}else{
					this.zdyState = true
					this.zdyIndex = index
				}
			},
			setTxt(){
				this.zdyList.push({type:1,content:this.txt})
				this.txt = ''
				this.txtShow = false
			},
			setcenter(){
				if(this.zdyList[this.dyIndex].type == 1){
					this.zdyList[this.dyIndex].type = 3
				}else if(this.zdyList[this.dyIndex].type == 3){
					this.zdyList[this.dyIndex].type = 1
				}
			},
			getLiveDylist(file, fileList) {
				this.zdyList.push({type:2,content:file.data})
			},
			//上移简介图片
			upFiles(){
				if(this.dyIndex === 0||this.dyIndex === ''){
					return
				}
				this.zdyList.splice(this.dyIndex-1,0,this.zdyList[this.dyIndex])
				this.zdyList.splice(this.dyIndex+1,1)
				this.dyIndex--
			},
			//下移简介图片
			dowFiles(){
				if(this.dyIndex === (this.zdyList.length-1) || this.dyIndex === ''){
					return
				}
				this.zdyList.splice(this.dyIndex+2,0,this.zdyList[this.dyIndex])
				this.zdyList.splice(this.dyIndex,1)
				this.dyIndex++
			},
			//删除简介图片
			delfiles(){
				if(!this.zdyList.length){
					return
				}
				this.zdyList.splice(this.dyIndex,1)
				this.dyIndex = ''
			},
			//获取所有模块列表
			get_color(){
				let params = {
					act:'get_fcib_all_module',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.get_fcib_all_module(params).then((res)=>{
					this.user_info.fcib_member_list_color = res.fcib_color_code
				})
			},
			changeColor(){
				if(this.user_info.fcib_member_list_color){
					let arr = []
					this.use_module.forEach((item)=>{
						arr.push(item.module_id)
					})
					let params = {
						act:'get_fcib_module_set',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						ids:arr.join(','),
						fcib_color_code:this.user_info.fcib_member_list_color
					}
					this.$api.get_fcib_module_set(params).then((res)=>{
						if(res.code == 0){
							this.get_color()
						}else{
							this.$message({
								showClose: false,
								message: res.msg,
								type: 'error',
								offset: 350,
								duration: 2000
							})
						}
					})
				}
			},
			useModel(item){
				if(item.is_use == 1){
					item.is_use = 0
				}else{
					item.is_use = 1
				}
			},
			//设置模块
			get_fcib_module_set(){
				let arr = []
				this.selModel.forEach((item)=>{
					if(item.is_use == 1){
						arr.push(item.module_id)
					}
				})
				if(arr.length < 8){
					this.$message({
						showClose: false,
						message: '至少选择八个模块',
						type: 'error',
						offset: 350,
						duration: 2000
					})
					return
				}
				let params = {
					act:'get_fcib_module_set',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids:arr.join(','),
					fcib_color_code:this.user_info.fcib_member_list_color
				}
				this.$api.get_fcib_module_set(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '保存成功',
							type: 'success',
							offset: 350,
							duration: 2000
						})
						this.get_fcib_use_module()
						this.moduleState = false
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 2000
						})
					}
				})
			},
			get_fcib_all_module(){
				let params = {
					act:'get_fcib_all_module',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					tpl_id: this.user_info.fcib_module_tpl_id
				}
				this.$api.get_fcib_use_module(params).then((res)=>{
					if(res.code == 0){
						this.moduleState = true
						this.selModel = res.data
					}
				})
			},
			constitution(item){
				this.$router.push('/modular_admin/constitution?state='+item.module_id)
			},
			setModel(state){
				this.user_info.fcib_module_tpl_id = state
				this.fcib_module_tpl_set()
			},
			//获取已设定模块
			get_fcib_use_module(){
				let params = {
					act:'get_fcib_use_module',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.get_fcib_use_module(params).then((res)=>{
					if(res.code == 0){
						this.use_module = res.data
					}
				})
			},
			get_company_info(){
				let params = {
					act:'get_company_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					this.user_info = res.data
					this.get_color()
				})
			},
			fcib_module_tpl_set(){
				let params = {
					act:'fcib_module_tpl_set',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					tpl_id: this.user_info.fcib_module_tpl_id
				}	
				this.$api.fcib_home_page_tpl_create(params).then((res)=>{
					if(res.code == 0){
						this.get_fcib_use_module()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 2000
						})
					}
				})
			},
			co_index_banner_list(){
				let params = {
					act:'co_index_banner_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.co_index_banner_list(params).then((res) => {
					this.dyList = []
					if(res.code == 0){
						this.dyList = res.data
					}
				})
				
			},
			fcib_index_banner_save(){
				let arr = []
				this.dyList.forEach((item,index)=>{
					if(item.photo_path){
						arr.push({...item,sort:index+1})
					}
				})
				if(arr.length == 0){
					this.$message({
						showClose: false,
						message: '请添加banner',
						type: 'error',
						offset: 350,
						duration: 200
					})
					return
				}
				let params = {
					act:'co_index_banner_save',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					json_data: JSON.stringify(arr)
				}	
				this.$api.co_index_banner_save(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '保存成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			fcib_index_banner_list(){
				let params = {
					act:'fcib_index_banner_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}	
				this.$api.fcib_home_page_tpl_create(params).then((res)=>{
					this.dyList = []
					if(res.code == 0){
						this.dyList = res.data
					}
				})
			},
			getimg(res,file,index,item) {
				item.photo_path = res.data
			},
			addDylist(){
				if(this.dyList.length > 4){
					this.$message({
						showClose: false,
						message: 'banner不能多于5个',
						type: 'error',
						offset: 350,
						duration: 2000
					})
					return
				}
				this.dyList.push({photo_path:'',link:'',con_id:0,price:0,type:0})
			},
			delDylist(index,item){
				if(this.dyList.length < 1){
					this.$message({
						showClose: false,
						message: 'banner不能低于1个',
						type: 'error',
						offset: 350,
						duration: 2000
					})
					return
				}else{
					this.dyList.splice(index,1)
				}
				// let params = {
				// 	act:'fcib_index_banner_del',
				// 	token: localStorage.getItem('token'),
				// 	user_id: localStorage.getItem('user_id'),
				// 	id:item.id
				// }	
				// this.$api.fcib_home_page_tpl_create(params).then((res)=>{
				// 	if(res.code == 0){
				// 		this.$message({
				// 			showClose: false,
				// 			message: '删除成功',
				// 			type: 'success',
				// 			offset: 350,
				// 			duration: 2000
				// 		})
				// 		this.fcib_index_banner_list()
				// 	}else{
				// 		this.$message({
				// 			showClose: false,
				// 			message: res.msg,
				// 			type: 'error',
				// 			offset: 350,
				// 			duration: 2000
				// 		})
				// 	}
				// })
				// this.dyList.splice(index,1)
			},
			//上移
			upFiles(index){
				if(index === 0){
					return
				}
				this.dyList.splice(index-1,0,this.dyList[index])
				this.dyList.splice(index+1,1)
			},
			//下移
			dowFiles(index){
				if(index === (this.dyList.length-1)){
					return
				}
				this.dyList.splice(index+2,0,this.dyList[index])
				this.dyList.splice(index,1)
			},
			//获取产品服务列表
			get_co_index_goods_list(){
				let params = {
					act:'co_index_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}	
				this.$api.co_index_goods_list(params).then((res)=>{
					if(res.code == 0){
						this.serviceNum = parseInt(res.data.co_pe_index_goods_num)
						this.serviceGoodsList = res.data.goods_list
					}
				})
			},
			//产品列表
			enterprise_goods_list(){
				let params = {
					act:'enterprise_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					keyword:this.goodsKeyword,
					status: 1,
					page: 1,
					size: 99
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.goodsList=[]
					if(res.code == 0){
						res.data.forEach((item,index)=>{
							this.goodsList.push({...item,checked:false})
							this.serviceGoodsList.forEach((val)=>{
								if(item.id == val.id){
									this.goodsList[index].checked = true
								}
							})
						})
					}
				})
			},
			chooseGoods(){
				this.servicegoodsstate = true
				this.enterprise_goods_list()
			},
			//点击商品
			setGoods(item){
				item.checked = !item.checked
			},
			//保存
			selectProduct(){
				let count = 0
				this.goodsList.forEach((item)=>{
					if(item.checked){
						count++
					}
				})
				if(count < 1){
					this.$message({
						showClose: false,
						message: '请选择产品',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				if(this.serviceNum == 2){
					if(count < this.serviceNum){
						this.$message({
							showClose: false,
							message: '请至少选择两个产品',
							type: 'error',
							offset: 350,
							duration: 1500
						})
						return
					}else if(count > this.serviceNum){
						this.$message({
							showClose: false,
							message: '最多选择两个产品',
							type: 'error',
							offset: 350,
							duration: 1500
						})
						return
					}
				}
				if(this.serviceNum == 4){
					if(count < this.serviceNum){
						this.$message({
							showClose: false,
							message: '请至少选择四个产品',
							type: 'error',
							offset: 350,
							duration: 1500
						})
						return
					}else if(count > this.serviceNum){
						this.$message({
							showClose: false,
							message: '最多选择四个产品',
							type: 'error',
							offset: 350,
							duration: 1500
						})
						return
					}
				}
				if(this.serviceNum == 6){
					if(count < this.serviceNum){
						this.$message({
							showClose: false,
							message: '请至少选择六个产品',
							type: 'error',
							offset: 350,
							duration: 1500
						})
						return
					}else if(count > this.serviceNum){
						this.$message({
							showClose: false,
							message: '最多选择六个产品',
							type: 'error',
							offset: 350,
							duration: 1500
						})
						return
					}
				}
				let arr = []
				this.goodsList.forEach((item)=>{
					if(item.checked){
						arr.push({
							goods_name:item.goods_name,
							id:item.id,
							sort:item.sort,
							goods_thumb:item.goods_thumb,
						})
					}
				})
				this.serviceGoodsList = arr
				this.servicegoodsstate = false
			},
			//产品服务tab点击
			serviceClick(item,index){
				this.currentService = index
				this.serviceNum = item.num
				if(this.serviceGoodsList.length != this.serviceNum){
					this.serviceGoodsList = []
				}
			},
			//产品服务保存设定
			saveSelGoods(){
				let arr = []
				this.serviceGoodsList.forEach((v) => {
					arr.push({goods_id:v.id,sort:v.sort})
				})
				let params = {
					act:'co_index_goods_set',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					json_data: JSON.stringify(arr),
					co_pe_index_goods_num: this.serviceNum
				}
				this.$api.co_index_goods_set(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: true,
							message: '服务产品设定成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						return
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
						return
					}
				})
			},
			serachGoods(){
				this.enterprise_goods_list()
			},
			//企业-专业版首页栏目模块排序信息
			co_index_module_sort_info(){
				let params = {
					act:'co_index_module_sort_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.co_index_module_sort_info(params).then((res)=>{
					if(res.code == 0){
						this.sortList = res.data
					}
				})
			},
			//上移箭头点击
			modelLeftClick(item,index){
				if(item.sort == 1 || item.sort == 2 || item.sort == 3){
					this.$message({
						showClose: true,
						message: '位置不可调整',
						type: 'warning',
						offset: 350,
						duration: 1000
					})
					return
				}else{
					if(index != 0 || index != 1){
						this.sortList[index] = this.sortList.splice(index-1,1,this.sortList[index])[0]
						let arr = []
						this.sortList.forEach((v,ind)=>{
							arr.push({
								en_name:v.en_name,
								hide:v.hide,
								module_id:v.module_id,
								name:v.name,
								sort:parseInt(ind) + 1
							})
						})
						this.sortList = arr
						this.co_index_module_sort_set()
					}
				}
			},
			//下移箭头点击
			modelRightClick(item,index){
				if(item.sort == 1 || item.sort == 2 || item.sort == 6){
					this.$message({
						showClose: true,
						message: '位置不可调整',
						type: 'warning',
						offset: 350,
						duration: 1000
					})
					return
				}else{
					if(index != 5){
						let sort1 = ''
						let sort2 = ''
						this.sortList[index] = this.sortList.splice(index+1,1,this.sortList[index])[0]
						sort1 = this.sortList[index].sort
						sort2 = this.sortList[parseInt(index)+1].sort
						this.sortList[index].sort = sort2
						this.sortList[parseInt(index)+1].sort = sort1
						this.co_index_module_sort_set()
					}
				}
			},
			//切换显示/隐藏状态
			checkHideStatus(item,index){
				if(item.hide == '0'){
					item.hide = '1'
				}else{
					item.hide = '0'
				}
				this.co_index_module_sort_set()
			},
			//企业-专业版首页栏目模块排序设置
			co_index_module_sort_set(){
				let arr = []
				this.sortList.forEach((v)=>{
					arr.push({
						module_id:v.module_id,
						sort:v.sort,
						hide:v.hide
					})
				})
				let params={
					act:'co_index_module_sort_set',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					json_data: JSON.stringify(arr)
				}
				this.$api.co_index_module_sort_set(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: true,
							message: '排序设置成功',
							type: 'success',
							offset: 350,
							duration: 1000
						})
						return
					}else{
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'warning',
							offset: 350,
							duration: 1000
						})
						return
					}
				})
			}
		}
	}
</script>

<style scoped>
	.content-box{
		width: 1170px;
		min-height: 960px;
		background: #FFFFFF;
		border-radius: 6px;
		flex-wrap: wrap;
		padding: 30px 60px 30px 137px;
		box-sizing: border-box;
	}
	.tct{
		text-align: center;
		text-indent: 0px;
	}
	.ntxt{
		text-align: left;
		text-indent: 30px;
	}
	.txt-box::-webkit-scrollbar{
		  display: none;
	}
	.bg-box::-webkit-scrollbar{
		display: none;
	}
	.text-second{
		overflow:hidden;
		text-overflow:ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical; 
	}
	.product-content::-webkit-scrollbar{
		display: none;
	}
</style>